import request from '@/utils/request'
//获取视频
export function videoInfo(data) {
    return request({
        url: `/MemberPost/GetPostVodList`,
        method: 'post',
        data
    })
}


//获取临时的id
function tempidInfo(data) {
    return request({
        url: `/Common/GetTempId`,
        method: 'post',
        data
    })
}


//获取临时id
export function getTempId() {
    var tempId = localStorage.getItem("tempid");
    // console.log("tempId", tempId);
    if (tempId) {
        return tempId;
    }
    tempidInfo().then((res) => {
        // console.log("tempId2", res);
        tempId = res;
        localStorage.setItem("tempid", res);
    }).catch((e) => {
        console.log(e);

    });
    return tempId;
}


//设置动态已读
export function postVodRead(data) {
    return request({
        url: `/MemberPost/SetPostVodRead`,
        method: 'post',
        data
    })
}

//视频列表
export function videoList(data) {
    return request({
        url: `/Member/GetMemberVideoList`,
        method: 'post',
        data
    })
}

//视频详情
export function videoDetail(data) {
    return request({
        url: `/Home/GetVideoDetail`,
        method: 'post',
        data
    })
}

//视频评论
export function videoComment(data) {
    return request({
        url: `/Home/GetVideoComment`,
        method: 'post',
        data
    })
}

//获取其他参赛视频列表
export function homeVideoList(data) {
    return request({
        url: `/Home/GetHomeVideoList`,
        method: 'post',
        data
    })
}

//点赞视频
export function createVideoLike(data) {
    return request({
        url: `/Home/CreateVideoLike`,
        method: 'post',
        data
    })
}

//取消点赞视频
export function cancelVideoLike(data) {
    return request({
        url: `/Home/CancelVideoLike`,
        method: 'post',
        data
    })
}

//点赞评论
export function createVideoCommentLike(data) {
    return request({
        url: `/Home/CreateVideoCommentLike`,
        method: 'post',
        data
    })
}

//取消点赞评论
export function cancelVideoCommentLike(data) {
    return request({
        url: `/Home/CancelVideoCommentLike`,
        method: 'post',
        data
    })
}

//点击确认按钮
export function createVideoComment(data) {
    return request({
        url: `/Home/CreateVideoComment`,
        method: 'post',
        data
    })
}